let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9O4aE")).then(() => parcelRequire('7Janc'));